import { maintenanceTaskSteps, maintenanceTasks } from '../maintenanceTask'
import { describeTable } from './describeTable'

describeTable(maintenanceTasks, {
  description: `The service catalogue (hinnasto / palvelut): one row per sellable service or maintenance job template, e.g. "Nuohous", "IV-kanavien puhdistus", "ILP-huolto". Booking copies a template onto a visit as a visit_tasks row (visit_tasks.maintenance_task_id), so this table is the ONLY reliable way to classify what a visit was — use category, never task-name keywords.
property_id IS NULL = company catalogue (the ~270 rows that matter; roughly two dozen of them produce 80 % of revenue). property_id IS NOT NULL = a homeowner's private task in the resident app (asukassovellus), not a Markku service — exclude from service analysis. The row named '__CUSTOM_TASK__' (category 'custom') is the sentinel behind ad-hoc visit tasks: the real title of such work is visit_tasks.task_name.
price is the default GROSS price (VAT 25.5 % included, the ERP shows it / 1.255 as ALV 0); the price actually charged is on visit_tasks.price.`,
  columns: {
    name: "Template name. '__CUSTOM_TASK__' is the ad-hoc placeholder, not a service.",
    category:
      'Service line: chimney = nuohous, hvac = ilmanvaihto, heat_pump = ilmalämpöpumput, roof = katto / sadevesijärjestelmät, yard = piha, safety, cleaning, home_maintenance, other; custom = the ad-hoc sentinel. Resident-app-only buckets (windows_doors, facade, foundation, interior, electrical, heating, property_care, water_sewer) and legacy inspection / maintenance also occur.',
    schedulingType:
      'periodic = every default_frequency_days; annual = once a year; seasonal_* = once in that season. NULL = one-off.',
    defaultFrequencyDays: 'Recurrence interval in days for periodic tasks.',
    estimatedDurationMinutes:
      'Default job length, used for slot sizing in booking.',
    estimatedCost:
      'Rough cost shown to residents for budgeting; not a price we charge.',
    price:
      'Default gross price in euros, VAT 25.5 % included. Net = price / 1.255. Overridable per visit.',
    deadline:
      'Calendar date for property-specific resident tasks; NULL on catalogue rows.',
    createdByUserId:
      'Who created the template (staff, or the resident for private tasks).',
    propertyId:
      'NULL = company catalogue; set = a private resident-app task for that property.',
    salesIncludedItems:
      'JSON array of strings: what the offer says is included. Snapshotted into offers.',
    salesPrerequisites:
      'JSON array of strings: preconditions for the service. Snapshotted into offers.',
    salesExclusions:
      'JSON array of strings: what is not included. Snapshotted into offers.',
  },
})

describeTable(maintenanceTaskSteps, {
  description:
    'Ordered checklist steps of a task template (työnohjaus for the technician), copied onto visit_task_steps at booking. Operational detail; rarely useful for business analysis.',
  columns: {
    stepNumber: 'Order within the task.',
    instruction: 'What the technician should do at this step.',
  },
})
